import React, { FC } from 'react'
import i18n from 'i18next'
import { money } from '../util'
import { IChipProps } from '../Bill'

const Chip: FC<IChipProps> = ({ card }) => {
  return (
    <div className='method'>
      <img className='icon' src={require('@img/payment/member-balance.png')} />
      <div className='dropdown no-arrow'>
        <div className='name'>{card?.name || i18n.t('pay.memberBalance')}</div>
        {card && card.balance != null && (
          <div className='info'>{i18n.t('pay.balanceN', { n: money(card.balance) })}</div>
        )}
      </div>
    </div>
  )
}

export default Chip
